var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProjects(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 44,
    viewBox: "0 0 51 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.3941 32.8947H10.9204V0H39.8678C45.6809 0 50.3941 4.71316 50.3941 10.5263V32.8947Z",
    fill: "#3DD9EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4467 32.8947H0.394043V10.5263C0.394043 4.71316 5.1072 0 10.9204 0C16.7335 0 21.4467 4.71316 21.4467 10.5263V32.8947Z",
    fill: "#7DEBF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4468 32.8945H28.0257V43.4208H21.4468V32.8945Z",
    fill: "#6C19FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3413 6.58008V11.8432H39.8676V17.1064H45.1308V6.58008H29.3413Z",
    fill: "#EB0000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1835 11.8418H5.65723V15.7892H16.1835V11.8418Z",
    fill: "#3DD9EB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjects);
export default __webpack_public_path__ + "static/media/Projects.d01b8e6e1f68c5fa2fdef2ca13d4ac2f.svg";
export { ForwardRef as ReactComponent };